import { render } from "./TelaInicial.vue?vue&type=template&id=4ac74cc2&scoped=true"
import script from "./TelaInicial.vue?vue&type=script&lang=js"
export * from "./TelaInicial.vue?vue&type=script&lang=js"

import "./TelaInicial.vue?vue&type=style&index=0&id=4ac74cc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac74cc2"]])

export default __exports__